import { useState, useEffect, memo } from 'react';

import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';

import { Box, Flex, useToast } from '@chakra-ui/react';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton'
import { manageDsrCustomPagesAccessibility, resetManageDsrCustomPagesAccessibility } from '../actions/dsr-page-accessibility-actions.js';

import { IoEyeSharp } from "react-icons/io5";
import { triggerLaunchdeckToast } from '../../global/helpers/global-helpers.js';
import LaunchdeckModal from '../../global/components/helper-components/components/LaunchdeckModal.jsx';
import LaunchdeckSwitch from '../../global/components/helper-components/components/LaunchdeckSwitch.jsx';


function DsrMassManageCustomPagesModal({
  dsrId,
  pDsrId,
  handleCloseModal,
  // Actions
  manageDsrCustomPagesAccessibility,
  resetManageDsrCustomPagesAccessibility,
  // Redux states
  isMobileView,
  updatedDsrCustomPagesView
}) {

  const toast = useToast();

  // Local state
  const [localState, setLocalState] = useState({
    dsrIdToDuplicate: "",
    dsrTitle: "",
    isShowAllPages: true,
    isLockAllPages: "",
  })


  useEffect(() => {
    if (updatedDsrCustomPagesView) {
      const { successfulPageAccessibilityUpdate, statusMessage } = updatedDsrCustomPagesView || {}

      if (successfulPageAccessibilityUpdate === true) {
        toast(
          triggerLaunchdeckToast({
            useCase: "show-success-state",
            label: statusMessage ? statusMessage : 'All custom pages updated',
            isMobileView
          })
        )
      } else {
        toast(
          triggerLaunchdeckToast({
            useCase: "show-error-state",
            label: "Unfortunately something went wrong. Please try again later.",
            isMobileView
          })
        )
      }

      resetManageDsrCustomPagesAccessibility()
    }
  }, [updatedDsrCustomPagesView])


  const handleChangeButton = () => {
    manageDsrCustomPagesAccessibility({
      ...dsrId && { dsrId },
      ...pDsrId && { pDsrId },
      isHideAllPages: !localState.isShowAllPages,
      isLockAllPages: localState.isLockAllPages
    })


  }


  const handleClickModalCloseButton = () => {
    handleCloseModal()
  }

  const renderContent = () => {
    return (<>
      <Flex w='100%' justify='center' mt='1em'>
        <Box as={IoEyeSharp} boxSize="3em" color="brand.500" />
      </Flex>
      <Flex fontSize='1.25em' color='brandDark.500' fontWeight='600' mt='1em' mb='2em' textAlign='center'>
        <Box>Manage custom page content</Box>
      </Flex>


      <Box w="100%" align="center">

        <Flex w={['100%', '80%']} minW={!isMobileView && '30em'} direction='column' align='center' px='2em'>

          <Flex w='100%' my='1em'>

            <Flex justify='center' w='100%'>

              <Box w='100%' maxW={!isMobileView && '25em'} p={isMobileView ? '1em' : '1em 2em'} justify='center' rounded='0.25em' bg='gray.50' border='1px solid' borderColor='gray.300' mb={'2em'}>
                <Flex w='100%' direction='column' justify='center' align='center' gap={4}>

                  <Box mb='1em' w='100%'>
                    <Flex w='100%' justify='space-between' align='center'>
                      <Box fontSize='0.875em'>Hide all pages</Box>
                      <Flex fontSize='0.875em' justify='space-between' align='center'>

                        <LaunchdeckSwitch
                          name="isShowAllPages"
                          isChecked={localState.isShowAllPages}
                          onChange={(event) => setLocalState(prevState => ({
                            ...prevState,
                            isShowAllPages: event.target.checked
                          }))}
                          yesContent='"Shown"'
                          noContent='""'
                          buttonWidth='4em'
                          additionalDistance={0.5}
                        />
                      </Flex>

                    </Flex>
                    <Box textAlign='left' mt='0.2em' fontSize='0.6em' color='gray.500'>Hidden pages will not appear to your audiences</Box>
                  </Box>

                  <Box mb='1em' w='100%'>
                    <Flex w='100%' justify='space-between' align='center'>
                      <Box fontSize='0.875em'>Lock all pages</Box>

                      <Flex fontSize='0.875em' justify='space-between' align='center'>
                        <LaunchdeckSwitch
                          name="isLockAllPages"
                          isChecked={localState.isLockAllPages}
                          onChange={(event) => setLocalState({
                            ...localState,
                            isLockAllPages: event.target.checked
                          })}
                          yesContent='"Locked"'
                          noContent='""'
                          buttonWidth='4em'
                          yesBg='brandPink.500'
                          additionalDistance={0.5}
                        />

                      </Flex>
                    </Flex>
                    <Box textAlign='left' mt='0.2em' fontSize='0.6em' color='gray.500'>Locked pages indicates pages whose content are made unavailable temporarily</Box>
                  </Box>
                </Flex>
              </Box>
            </Flex>
          </Flex>
        </Flex>


        <Flex justify='center' py='0.625em' mb='1em'>
          <LaunchdeckButton bg='brand.500' color='white' px='3em' label='Save' onClick={() => handleChangeButton()} />
        </Flex>

      </Box>
    </>)
  }


  return (
    <LaunchdeckModal
      // title=''
      handleCloseModal={handleClickModalCloseButton}
      showModal={true}
      maxW='35em'
    >

      {renderContent()}
    </LaunchdeckModal>

  )
}


const mapStateToProps = (state) => ({
  isMobileView: state.mobileViewMode.isMobileView,
  updatedDsrCustomPagesView: state.dsrCustomPagesAccessibility.results
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      manageDsrCustomPagesAccessibility,
      resetManageDsrCustomPagesAccessibility
    },
    dispatch,
  )


export default memo(withRouter(connect(mapStateToProps, mapDispatchToProps)(DsrMassManageCustomPagesModal)))
